import { invariant } from "@coinbot/forge-api/helpers";

import { midgard } from "./client";

// TODO: might be helpful, but also should be part of Swapkit-provided API
export async function getBalanceByAddress({ address }: { address: string | undefined }) {
  invariant(address, "Address must not be empty");

  throw Error("getBalanceByAddress is not implemented");

  const { data: balance } = await midgard.get<unknown>(`balance/${address}`);

  invariant(balance, "Balance response was empty");

  return {};
}
